export const ROUTABLE_KIND_AGENT: Record<string, { agent: string; label: string }> = {
  estimate: { agent: 'smeta', label: 'Сметчик' },
  specification: { agent: 'mto', label: 'МТО' },
  schedule: { agent: 'ksp', label: 'КСП' },
  tech_spec: { agent: 'pto', label: 'ПТО' },
  technical_spec: { agent: 'pto', label: 'ПТО' },
  drawing: { agent: 'pto', label: 'ПТО' },
  ks_act: { agent: 'econ', label: 'Экономист' },
};

export function humanSize(bytes: number): string {
  if (!Number.isFinite(bytes) || bytes <= 0) return '—';
  const units = ['Б', 'КБ', 'МБ', 'ГБ'];
  let idx = 0;
  let val = bytes;
  while (val >= 1024 && idx < units.length - 1) {
    val /= 1024;
    idx += 1;
  }
  const formatted = idx >= 2 ? val.toFixed(2) : Math.round(val).toString();
  return `${formatted.replace('.', ',')} ${units[idx]}`;
}

export function formatDateTime(value: string): string {
  return new Date(value).toLocaleString('ru-RU', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}
